import {WebsocketService} from './websocket.service';


export function websocketServiceFactory() {
  return new WebsocketService();
}
